<template>
  <MDBToast v-if="isToastVisible" :class="isError ? 'toast-red' : 'toast-green'">
    {{ toastMessage }}
  </MDBToast>
</template>

<script>
import { ref, onBeforeUnmount } from 'vue';

export default {
  name: 'ToastComponent',
  setup(_, { expose }) {
    const isToastVisible = ref(false);
    const isError = ref(false);
    const toastMessage = ref('');

    let hideTimer = null;
    let lastKey = null;       // evita duplicado inmediato
    const WINDOW_MS = 800;    // ventana para ignorar duplicado
    let lastShownAt = 0;

    const showToast = (error = false, message = '') => {
      const msg = message || (error ? 'Error al realizar la acción' : 'Acción realizada con éxito');
      const key = `${error}|${msg}`;
      const now = Date.now();

      // Ignora el MISMO mensaje 2 veces seguidas en < WINDOW_MS
      if (lastKey === key && (now - lastShownAt) < WINDOW_MS) return;

      lastKey = key;
      lastShownAt = now;

      // limpia timers pendientes
      if (hideTimer) clearTimeout(hideTimer);

      isError.value = error;
      toastMessage.value = msg;
      isToastVisible.value = true;

      // Mantén visible 3s (o el tiempo que quieras)
      hideTimer = setTimeout(() => {
        isToastVisible.value = false;
      }, 3000);
    };

    onBeforeUnmount(() => {
      if (hideTimer) clearTimeout(hideTimer);
    });

    expose({ showToast });

    return { isToastVisible, isError, toastMessage };
  },
};
</script>

<style>
.toast-green {
  height: 65px !important;
  width: 400px !important;
  position: fixed;
  top: 20px;
  right: 20px;
  background-color: #319b4a;
  color: #fff;
  border-radius: 5px;
  padding: 15px 20px;
  animation: fadeIn 0.2s, fadeOut 0.2s 2.8s;
  z-index: 9999;
  text-align: center;
}

.toast-red {
  min-height: 65px !important;
  min-width: 330px !important;
  position: fixed;
  top: 20px;
  right: 20px;
  background-color: #e91515;
  color: #fff;
  border-radius: 5px;
  padding: 15px 20px;
  animation: fadeIn 0.2s, fadeOut 0.2s 2.8s;
  z-index: 9999;
  text-align: center;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}
</style>
